module.exports = __webpack_public_path__ + "img/capsule-4@2x.e58b0a1f.webp";